<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>TRAFFIC</h1>
    <app-help screen="traffic"></app-help>
  </div>
</div>

@if (ts.isLoaded | async) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <h2>Net Price Calculator Usage</h2>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-traffic-chart></app-traffic-chart>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button (click)="ts.populateChartData()">All periods</button>
      @if ((ts.traffic | async)?.trafficData?.length >= 12) {
        <button mat-button (click)="ts.populateChartData(12)">Latest 12 months</button>
      }
      <button mat-button (click)="ts.downloadButtonPush()">Download Data</button>
    </mat-card-actions>
  </mat-card>
} @else {
  <p class="traffic-empty">Traffic data is not available for this school yet.</p>
}
